import styled from '@mui/system/styled';

const StyledDivider = styled('div')(({ size }: { size: number }) => ({
  margin: `${size}px 0`,
  height: '1px',
  padding: 0,
  background: '#ebedf0',
  position: 'relative',
  '& span': {
    position: 'absolute',
    display: 'inline-block',
    top: '-19px',
    left: '50%',
    backgroundColor: '#fff',
    padding: '8px',
    fontSize: '16px',
    transform: 'translate(-50%, 0)'
  }
}));

export default StyledDivider;
